import { Checkbox } from 'antd';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface CheckboxProps {
  label?: string;
  className?: string;
  [key: string]: any;
}

export const CustomCheckbox: FC<CheckboxProps> = ({ label, className = '', ...checkboxProps }) => {
  return (
    <div className={twMerge('flex items-center gap-2', className)}>
      <Checkbox {...checkboxProps} />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
};

export default CustomCheckbox;
